export default __webpack_public_path__ + "static/media/upload_icon.0f6b245b.svg";